export default __webpack_public_path__ + "static/logoHomeUniversoColeMB-547bc1f5a18677c87e6a48a58cf95af9.png";